<template>
  <ViewWrapper headingText="Permissions">
    <v-container fluid grid-list-xl>
    <div>
      <v-data-table
        :headers="columns"
        :items="rows"
        :pagination.sync="pagination"
        :loading="loading"
        :total-items="totalRows"
        :rows-per-page-items="pageCountOptions"
        item-key="id"
        class="elevation-1"
        must-sort
        no-data-text="No data found"
        no-results-text="No results found"
        @update:pagination="search"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="(header) in props.headers"
              :key="header.value"
              v-show="header.visible"
              :class="['font-weight-bold text-xs-left column sortable pa-1 ma-0', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon small>arrow_upward</v-icon>
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <tr>
            <td
              v-for="(header) in columns"
              :key="header.value"
              v-show="header.visible"
              class="pa-1 ma-0"
              :class="(header.type === 'boolean') ? 'text-xs-center' : ''"
            >
              <template v-if="header.type === 'boolean'">
                <span v-if="props.item[header.value]">Yes</span>
                <div v-else class="error white--text">No</div>
              </template>

              <template v-else-if="header.type === 'money'">
                {{ moneyNoSign(props.item[header.value] / 100) }}
              </template>

              <template v-else-if="header.type === 'date'">
                {{ dateUtc(props.item[header.value]) }}
              </template>

              <template v-else class="text-capitalize">
                {{ props.item[header.value] }}
              </template>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          No results found
        </template>
      </v-data-table>
    </div>

    </v-container>
  </ViewWrapper>
</template>

<script>
import Moment from 'moment'

import ViewWrapper from '@/components/ViewWrapper'
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  components: { ViewWrapper },
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      columns: [
        {
          value: 'id',
          text: 'ID',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'name',
          text: 'Name',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'type',
          text: 'Type',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'model',
          text: 'Model',
          sortable: true,
          visible: true,
          export: true
        },
        {
          value: 'description',
          text: 'Description',
          sortable: false,
          visible: true,
          export: true
        },
        {
          value: 'is_active',
          text: 'Active',
          sortable: true,
          visible: true,
          export: true,
          type: 'boolean'
        }
      ],
      pagination: this.defaultPagination(),
      rows: [],
      totalRows: 0,
      pageCountOptions: [5, 10, 25],
      loading: true
    }
  },

  methods: {
    defaultPagination () {
      return {
        sortBy: 'id',
        descending: false,
        rowsPerPage: 25,
        page: 1
      }
    },

    async search () {
      this.loading = true

      try {
        let result = await this.api({
          method: 'get',
          url: '/permissions',
          params: {
            page: this.pagination.page - 1,
            perPage: this.pagination.rowsPerPage,
            orderBy: this.pagination.sortBy,
            orderDirection: this.pagination.descending ? 'desc' : 'asc'
          }
        })
        this.rows = result.data.rows
        if (Array.isArray(result.data.rows)) {
          this.totalRows = result.data.rows.count
        } else {
          this.totalRows = 0
        }
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        this.loading = false
      }
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/Permissions.vue